import {BdState} from '@bindoc-projects/geographic-domain-lib';
import {BdMapsStateSelectHandler} from './select-handler';
import {BdMapsStateSelectOptions} from './select-options';

export class BdMapsStateSelectSingleHandler extends BdMapsStateSelectHandler<BdState> {

  public showResetOption = true;

  private _initialStateId: number;

  public selectById(stateId: number): void {
    if (!this._states) {
      return;
    }

    const filtered: BdState[] = this._states.filter(state => state.id === stateId);

    if (!!filtered && filtered.length > 0) {
      this.updateSelection(filtered[0]);
    }
  }

  updateSelection(selection: BdState): void {
    this.selectedResources = selection;

    this.statesSelect$.next(selection);
  }

  get initialStateId(): number | null {
    return this._initialStateId;
  }

  set initialStateId(value: number | null) {
    this._initialStateId = value;

    this.selectById(value);
  }

  get states(): BdState[] {
    return this._states;
  }

  set states(value: BdState[]) {
    this._states = value.sort((a, b) => {
      if (!a || !b) {
        return !a ? 1 : -1;
      }

      return a.name.localeCompare(b.name);
    });
    this.statesOptions = this._states;
    this.selectedResources = null;

    if (this._initialStateId) {
      this.selectById(this._initialStateId);
    }
  }

  set options(options: BdMapsStateSelectOptions) {
    this._options = options;
    this.states = this._getStateOptions(this.states, options.includeBund);
  }
}
